import { z } from 'zod';
import { pageInfo, viewDateValue } from '../../crew/schema/filters.js';
import { Sidekick } from '../../crew/schema/sidekick.js';
const tokens = z.object({
    inputTokens: z.number(),
    cacheReadTokens: z.number(),
    cacheWriteTokens: z.number(),
    outputTokens: z.number(),
});
const user = z.object({
    id: z.number(),
    email: z.string(),
    firstName: z.string().nullable(),
    lastName: z.string().nullable(),
});
const store = z.object({ id: z.number(), name: z.string() });
const conversation = z.object({
    id: z.number(),
    name: z.string(),
    store,
    user,
    createdOn: z.string(),
    questionCount: z.number(),
    costUsd: z.number(),
    // the thumbs up or down left on answers in the period, with any comment
    feedback: z.array(z.object({
        messageId: z.number(),
        sentiment: z.enum(Sidekick.UserSentiment),
        comment: z.string().nullable(),
    })),
});
const message = Sidekick.messageSchema
    .pick({
    id: true,
    role: true,
    content: true,
    createdOn: true,
    userSentiment: true,
    userComment: true,
})
    .extend({
    usage: Sidekick.usageSchema.nullable(),
    // the page a question was asked from
    pageContext: Sidekick.pageContextSchema.nullable(),
    // null when the answer has no usage or its model has no rate
    costUsd: z.number().nullable(),
    toolCalls: z.array(z.string()),
    failed: z.boolean(),
});
export const commandSidekick = {
    search: z.object({
        // only conversations with a message in this period; the summary covers the same period
        createdOn: viewDateValue,
        // only conversations with an answer rated one of these ways in the period
        sentiments: z.array(z.enum(Sidekick.UserSentiment)).optional(),
        // only conversations started by someone in the Corso organization, or only by merchants
        isCorsoUser: z.boolean().optional(),
        // matches a conversation's name or its user's email
        searchTerm: z.string().optional(),
        cursor: z
            .object({ id: z.number(), direction: z.enum(['next', 'prev']) })
            .nullable(),
    }),
    list: z.object({
        summary: tokens.extend({
            costUsd: z.number(),
            conversationCount: z.number(),
            questionCount: z.number(),
            answerCount: z.number(),
            // answers from before usage was recorded, or on a model without a rate
            unpricedAnswerCount: z.number(),
        }),
        // one page of the conversations the summary covers
        conversations: z.array(conversation),
        pageInfo,
    }),
    detail: conversation.omit({ questionCount: true, feedback: true }).extend({
        messages: z.array(message),
    }),
};
//# sourceMappingURL=sidekick.js.map